import React from 'react';

import isArray from 'lodash/isArray';

import { DateRangeFormatter } from '@gogame/intl-ts';

const SpendAdjustmentsTitle = ({ period, owner, affiliate }) => {
  const normalizedPeriod = isArray(period) ? period : [period.from, period.to];

  return (
    <React.Fragment>
      <DateRangeFormatter
        value={normalizedPeriod}
        template={'LL'}
        timeZone={'utc'}
      />
      {` / ${affiliate.name} / by ${owner.name}`}
    </React.Fragment>
  );
};

export default SpendAdjustmentsTitle;
